module.exports = __webpack_public_path__ + "img/24-uhavenBranding.3f123781.jpg";